import { createFileRoute } from '@tanstack/react-router'
import SitesPage from '@/pages/dashboard/sites-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota index para /dashboard/$dashboardId/sites
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sites/',
)({
  component: function SitesIndexRoute() {
    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_SITES_BLOG}>
        <SitesPage />
      </ProtectedRoute>
    )
  },
})
